import * as Sentry from '@sentry/react';
import { Component as ReactComponent } from 'react';
import BrandedRecoveryScreen from './BrandedRecoveryScreen';
import {
  isChunkLoadError,
  shouldAutoReloadChunkLoadError,
} from '../utils/chunkLoadError';

const DEFAULT_SECTION = 'app';

function reloadWindow() {
  if (typeof window === 'undefined') return;
  window.location.reload();
}

export default class LazyChunkErrorBoundary extends ReactComponent {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (!isChunkLoadError(error)) return;

    const section = this.props.section || DEFAULT_SECTION;
    Sentry.captureException(error, {
      tags: {
        ui_section: section,
        error_boundary: 'LazyChunkErrorBoundary',
      },
      extra: {
        componentStack: info.componentStack,
      },
    });

    if (typeof window !== 'undefined' && shouldAutoReloadChunkLoadError({ section })) {
      window.setTimeout(() => {
        (this.props.reload || reloadWindow)();
      }, 0);
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (!isChunkLoadError(error)) throw error;

    return (
      <BrandedRecoveryScreen
        message="Failed to load updated app files."
        actionLabel="Reload App"
        onAction={this.props.reload || reloadWindow}
      />
    );
  }
}
